/* zd-upsell.js - the post add-to-cart offer (snippets/zd-post-add-offer.liquid, rendered by the zd cart drawer).
   Listens to zd:cart:before-open from window.ZDCart.add (assets/zd-cart.js): after a successful add it shows the
   offer instead of the drawer when all of these hold:
     - the offer is on the page ([data-zd-pao]) and has not been shown in this browser session (sessionStorage),
     - the drawer was not already open (adds from inside the drawer never trigger it),
     - none of the added items is a variant of the offer product, and the drawer has no line of it.
   Buttons: "Add to order" applies data-code (GET /discount/CODE) when one is set, adds the offer variant, then the
   drawer opens (ZDCart.add). "No thanks" goes to checkout (data-decline="checkout") or opens the drawer
   (data-decline="drawer"). Close / Escape / scrim open the drawer: the shopper always sees the item they added.
   Countdown: data-minutes from the first show, kept in sessionStorage, stops at 00:00. Money comes from Liquid only. */
(function () {
  'use strict';
  if (window.ZDUpsell) return;
  var SEEN = 'zd_pao_seen', END = 'zd_pao_end';
  var trigger = null, timer = null;

  function ss(k, v) {
    try { if (v === undefined) return sessionStorage.getItem(k); sessionStorage.setItem(k, v); } catch (e) { return null; }
  }
  function el() { return document.getElementById('ZdPostAddOffer'); }
  function isShown() { var o = el(); return !!(o && !o.hidden); }
  function rootUrl() { return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/'; }

  function inCart(o) {
    var d = document.getElementById('ZdCartDrawer');
    var h = o.getAttribute('data-handle');
    return !!(d && h && d.querySelector('[data-zd-cart-line][data-handle="' + h + '"]'));
  }
  function wanted(o, detail) {
    if (!o || ss(SEEN) || detail.drawerOpen) return false;
    var ids = (o.getAttribute('data-variants') || '').split(',');
    var items = detail.items || [];
    for (var i = 0; i < items.length; i++) if (ids.indexOf(String(items[i].id)) > -1) return false;
    return !inCart(o);
  }

  function tick() {
    var o = el();
    var clock = o && o.querySelector('[data-zd-pao-clock]');
    if (!clock) return;
    var end = +ss(END);
    if (!end) { end = Date.now() + (+o.getAttribute('data-minutes') || 15) * 60000; ss(END, String(end)); }
    var left = Math.max(0, Math.round((end - Date.now()) / 1000));
    clock.textContent = String(Math.floor(left / 60)).padStart(2, '0') + ':' + String(left % 60).padStart(2, '0');
    if (left <= 0 && timer) { clearInterval(timer); timer = null; }
  }

  function show(t) {
    var o = el();
    trigger = t || document.activeElement;
    ss(SEEN, '1');
    o.hidden = false;
    document.documentElement.classList.add('zd-pao-open');
    tick();
    if (!timer) timer = setInterval(tick, 1000);
    var add = o.querySelector('[data-zd-pao-add]');
    setTimeout(function () { if (add && isShown()) add.focus({ preventScroll: true }); }, 50);
    document.dispatchEvent(new CustomEvent('zd:offer:show'));
  }
  function hide() {
    var o = el();
    if (!o || o.hidden) return;
    o.hidden = true;
    document.documentElement.classList.remove('zd-pao-open');
    if (timer) { clearInterval(timer); timer = null; }
  }
  function toDrawer() {
    hide();
    if (window.ZDCart) window.ZDCart.open(trigger);
  }

  document.addEventListener('zd:cart:before-open', function (e) {
    var o = el();
    if (!wanted(o, e.detail || {})) return;
    e.preventDefault();
    show(e.detail.trigger);
  });

  document.addEventListener('click', function (e) {
    var t = e.target;
    var o = el();
    if (!t || !t.closest || !o || !o.contains(t)) return;
    if (t.closest('[data-zd-pao-close]')) { e.preventDefault(); toDrawer(); return; }
    if (t.closest('[data-zd-pao-decline]')) {
      e.preventDefault();
      if (o.getAttribute('data-decline') === 'drawer') toDrawer();
      else { hide(); window.location.href = o.getAttribute('data-checkout') || rootUrl() + 'checkout'; }
      return;
    }
    var btn = t.closest('[data-zd-pao-add]');
    if (!btn || !window.ZDCart) return;
    e.preventDefault();
    var err = o.querySelector('[data-zd-pao-err]');
    if (err) err.hidden = true;
    btn.disabled = true;
    btn.setAttribute('aria-busy', 'true');
    var code = o.getAttribute('data-code');
    var pre = code
      ? fetch(rootUrl() + 'discount/' + encodeURIComponent(code), { credentials: 'same-origin' }).catch(function () {})
      : Promise.resolve();
    pre.then(function () {
      return window.ZDCart.add([{ id: +o.getAttribute('data-variant'), quantity: 1, properties: { _zd_offer: 'post-add' } }], trigger);
    }).then(function () {
      hide();
    }, function (x) {
      if (err) { err.textContent = (x && x.message) || 'Could not add it. Please try again.'; err.hidden = false; }
    }).then(function () {
      btn.disabled = false;
      btn.removeAttribute('aria-busy');
    });
  });

  document.addEventListener('keydown', function (e) {
    if (!isShown()) return;
    if (e.key === 'Escape') { toDrawer(); return; }
    if (e.key !== 'Tab') return;
    var card = el().querySelector('[data-zd-pao-card]');
    var f = Array.prototype.filter.call(card.querySelectorAll('button:not([disabled]),a[href]'), function (x) { return x.offsetWidth > 0; });
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && (document.activeElement === first || !card.contains(document.activeElement))) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && (document.activeElement === last || !card.contains(document.activeElement))) { e.preventDefault(); first.focus(); }
  });

  window.ZDUpsell = { show: show, hide: hide };
})();
